export const COST_KEYS = {
  INTERSECTION: "intersection",
  AUTO_DELAY: "autoPassengerDelay",
  PLANNING_CONSTRUCTION_ROW: "planningConstructionROW",
  POST_OPENING: "postOpeningCosts",
  SAFETY: "safety",
  TRUCK_DELAY: "truckDelay",
  TOTAL_COST: "totalCost",
};

export const COST_LABELS = {
  AUTO_DELAY: "Auto Passenger Delay",
  PLANNING_CONSTRUCTION_ROW: "Planning, Construction & ROW",
  POST_OPENING: "Post-Opening Costs",
  SAFETY: "Safety",
  TRUCK_DELAY: "Truck Delay",
};

export const BENEFIT_COST_KEYS = {
  INTERSECTION: COST_KEYS.INTERSECTION,
  AUTO_DELAY: COST_KEYS.AUTO_DELAY,
  TRUCK_DELAY: COST_KEYS.TRUCK_DELAY,
  SAFETY: COST_KEYS.SAFETY,
  VALUE_OF_BENEFITS: "netPresentValueOfBenefits",
  VALUE_OF_COSTS: "netPresentValueOfCosts",
  BC_RATIO: "benefitCostBCRatio",
  DELAY_BC_RATIO: "delayBC",
  SAFETY_BC_RATIO: "safetyBC",
};
